import { loadResources } from '../lib/_preload.js';
import { loadFromExternal } from '../lib/_loadPost.js';

//loadPost系ページ。カテゴリで絞り込みをした時
export const pageStatus = {
	count: 1,
	max: 0,
	totalCount: 0,
	perPage: 0,
	category: "",
	tag: "",
	loadInit: function(){
		
	},
	reset: function(){
		return new Promise((resolve, reject) => {
			pageStatus.count 		= 1;
			pageStatus.max 			= 1;
			pageStatus.category 	= "";
			pageStatus.tag 			= "";
			pageStatus.perPage 		= 0;
			pageStatus.totalCount 	= 0;
			
			let $perPage = document.querySelector("[data-per-page]");
			if( $perPage ){
				if( $perPage ){
					pageStatus.totalCount 	= parseInt( $perPage.getAttribute("data-total-count") );
					pageStatus.perPage 		= parseInt( $perPage.getAttribute("data-per-page") );
					pageStatus.max 			= Math.ceil( pageStatus.totalCount/pageStatus.perPage );
				}
				//パラメータをチェックする
				resolve();
			}else{
				console.log("data-per-pageがDOMにありません");
				resolve();
			}
		});
	}
}

export let changeURL = (url) => {
	return new Promise((resolve, reject) => {
		let state = { page_id: location.pathname };
		history.pushState(state, "", url);
		loadingProgress(0, isDetail( url) );
		resolve();
	});
}
const originalPushState 	= history.pushState;
const originalReplaceState 	= history.replaceState;

// pushStateとreplaceStateをラップ
history.pushState = function(state, title, url) {
	const result = originalPushState.apply(this, arguments);
	const event = new Event('urlchange');
	event.state = state;
	window.dispatchEvent(event);
	return result;
};

history.replaceState = function(state, title, url) {
	const result = originalReplaceState.apply(this, arguments);
	const event = new Event('urlchange');
	event.state = state;
	window.dispatchEvent(event);
	return result;
};

export let disablePage = () => {
	return new Promise((resolve, reject) => {
		let $body = document.querySelector("body");
		let $main = document.querySelector("[data-load-wrap]");
		$body.classList.add("change_page");
		$main.addEventListener("transitionend", function(){
			resolve();
		}, { 'once': true });
	});
}
/*
ページロード時にコンテンツを読み込むために呼び出される関数
*/
export let loadPageContent = ( url, folder ) => {
	let $body 			= document.querySelector("body");
	let needLoadSummary = ["works", "magazine", "member"];
	let isDetailPage = isDetail(url);
	//console.log("isDetailPage: ", isDetailPage);
	loadingProgress(25, isDetailPage);
	return new Promise( (resolve, reject) => {
		//return false
		fetch(url).then(response => response.text()).then(html => {
			const tempDiv 		= document.createElement('div');
			tempDiv.innerHTML 	= html;
			changeBodyData(html);
			const title 		= tempDiv.querySelector("title").innerText;
			document.title 		= getPageTitle(title);
			const targetElement = tempDiv.querySelector(`[data-load-wrap] [data-load-inner]`);
			//console.log(targetElement);
			document.querySelector("[data-load-wrap] [data-load-inner]").innerHTML = targetElement.innerHTML;
			loadingProgress(50, isDetailPage);
			let imgArry = [];
			
			//console.log(imgs);
			if( needLoadSummary.includes(folder) ){
				loadFromExternal.init().then( () => {
					setTimeout(function(){
						let imgs 	= tempDiv.querySelectorAll("main img");
						loadingImage(imgs).then( ()=> {
							loadingProgress(100, isDetailPage);
							setTimeout(function(){
								$body.classList.remove("change_page");
								resolve();
							}, 500);
						});
					});
				});
			}else{
				loadingProgress(100, isDetailPage);
				setTimeout(function(){
					$body.classList.remove("change_page");
					resolve();
				}, 200);
				resolve();
			}
			
			function loadingImage(imgs){
				return new Promise( (resolve, reject) => {
					imgs.forEach( ($img, index) => {
						let src = $img.getAttribute("src");
						if( src && src != "" && !$img.complete){
							if(index < 10){
								imgArry.push( $img );
							}
						}
					});
					if(imgArry.length > 0){
						loadResources( imgArry ).then( ()=> {
							resolve();
						});
					}else{
						resolve();
					}
				});
			}
		})
		.catch(error => console.error('Error:', error));
	});
}
//ページ遷移時に呼び出し
export let changeBodyData = ( html ) => {
	const parser 	= new DOMParser();
	const doc 		= parser.parseFromString(html, 'text/html');
	let $loadedBody = doc.body;
	let $body 		= document.querySelector("body");
	let dataPage 			= $loadedBody.getAttribute("data-page");
	let dataPageCategory 	= $loadedBody.getAttribute("data-page-category");
	
	$body.setAttribute("data-page", dataPage);
	$body.setAttribute("data-page-category", dataPageCategory);
	checkGlobalNav(dataPage)
}

export let closeGlobalNav = () => {
	let $html = document.documentElement;
	if( $html.classList.contains("u-show_menu") ){
		$html.classList.remove("u-show_menu");
	}
}

//companyのリンクがページによって変わるのでここで調整
let checkGlobalNav = (pageName) => {
	let $glbnavs = document.querySelectorAll("#g-nav li a");
	$glbnavs.forEach( ($n) => {
		let href = $n.getAttribute("href");
		if( href.includes("company") || href.includes("#") ){
			let hash = $n.getAttribute("data-hash");
			if( pageName === "company" ){
				$n.removeAttribute("data-nav");
				$n.setAttribute("data-scroll", "");
				$n.setAttribute("href", `${hash}`);
			}else{
				$n.removeAttribute("data-scroll");
				$n.setAttribute("data-nav", "");
				if( hash === "#main"){
					$n.setAttribute("href", `/company/`);
				}else{
					$n.setAttribute("href", `/company/${hash}`);
				}
			}
		}
	});
}

export let loadingProgress = (progress, isDetailPage) => {
	let $loading = document.querySelector("#loading .bar");
	if( isDetailPage ){
		$loading = document.querySelector(".c-loading_detail .bar");
		if( !$loading ){
			$loading = document.querySelector("#loading .bar");
		}
	}
	//console.log(isDetailPage, $loading, progress);
	$loading.style.width = `${progress}%`;
}
export let isDetail = ( url ) => {
	let arry = url.split("/");
	let folder = arry[1];
	let hasDetails = ["works", "magazine", "member"];
	if( arry.length === 4 && hasDetails.includes(folder) ){
		return true
	}else{
		return false
	}
}

export let getPageCategory = ()=> {
	let path = location.pathname;
	let arry = path.split("/");
	//console.log(arry);
	return arry[1];
}

export let setURLtoPager = (nextURL, prevURL) => {
	console.log("set Pager:", nextURL, prevURL);
	let $prev = document.querySelector(`[data-page-detail] a[data-nav-prev]`);
	let $next = document.querySelector(`[data-page-detail] a[data-nav-next]`);
	//NEXT
	if(nextURL != ""){
		if( $next.classList.contains("disable") ){
			$next.classList.remove("disable");
		}
		$next.setAttribute("href", nextURL);
	}else{
		if( !$next.classList.contains("disable") ){
			$next.classList.add("disable");
		}
	}
	//PREV
	if(prevURL != ""){
		if( $prev.classList.contains("disable") ){
			$prev.classList.remove("disable");
		}
		$prev.setAttribute("href", prevURL);
	}else{
		if( !$prev.classList.contains("disable") ){
			$prev.classList.add("disable");
		}
	}
}
export let getPageTitle = (title) => {
	let t = title;
	//let path = location.pathname;
	return t;
}